import React from 'react'
import { create } from 'zustand'
import Selector from '@/components/zthd/Selector'
import { usePid2, usePidJP } from '@/components/DropdownPid'
import { hasProductPackages, useProductPackages } from '@/lib/package-utils'

export const usePackageName = create((set) => ({
  value: '',
  update: (value) => set({ value }),
}))

export const isSelectedPackageName = (packageName, packageNames = []) => {
  // 确保 packageNames 是数组
  const packageNamesArray = Array.isArray(packageNames)
    ? packageNames
    : packageNames
    ? [packageNames]
    : []

  if (packageNamesArray.includes('total') || packageNamesArray.includes('') || packageNamesArray.length === 0) {
    return true
  }
  return packageNamesArray.includes(packageName) || (packageNamesArray.includes('main') && !packageName)
}

export const CustomDropdown = () => {
  const pids = usePid2((state) => state.pids)
  const pid = pids.join(',')
  const value = usePackageName((state) => state.value)
  const update = usePackageName((state) => state.update)
  if (!hasProductPackages(pid)) return null
  return <DropdownPackageName pid={pid} value={value} update={update} />
}

export const DropdownPackageName = ({ pid: selectedPid, value, update }) => {
  const pids = usePid2((state) => state.pids)
  const pid = selectedPid || pids.join(',')
  const apps = useProductPackages(pid)
  if (!apps.length) return null
  return (
    <Selector
      datas={apps}
      showLabel
      labelName="App"
      value={value}
      update={update}
    />
  )
}

export const CustomDropdownJP = () => {
  const pids = usePidJP((state) => state.pids)
  const pid = pids.join(',')
  const value = usePackageName((state) => state.value)
  const update = usePackageName((state) => state.update)
  const apps = useProductPackages(pid)
  if (pid !== '14' && pid !== 'total3') return null
  return (
    <Selector
      datas={apps}
      showLabel
      labelName="App"
      value={value}
      update={update}
    />
  )
}

export default CustomDropdown
